import { MAX_TABLE_ROWS } from '@/main/app.constants';
import { isCanceled } from '@/utilities/http.utilities';
import { errorToast } from '@/utilities/toast.utilities';
import { sqTablesApi } from '@seeqdev/api/endpoint/TablesApi';
import type { TableJoinInput } from '@/tableDefinitionEditor/tableDefinition.types';
import type { Filter } from '@seeqdev/api/model/Filter';
import type { PropertiesForItemUUIDColumn, TableFormula, TableResultOutputV1 } from '@seeqdev/api/model/models';

export interface FetchMaterializedTableInput {
  tableDefinitionId: string;
  columnsToInclude?: string[];
  propertiesToInclude?: PropertiesForItemUUIDColumn[];
  includeOverrides?: boolean;
  tableFormulas?: TableFormula[];
  cancellationGroup?: string;
  limit?: number;
  cursorKey?: string;
  filter?: Filter;
  tablesToJoin?: TableJoinInput[];
}
const fetchMaterializedTable = async ({
  tableDefinitionId,
  columnsToInclude,
  propertiesToInclude,
  includeOverrides,
  tableFormulas,
  tablesToJoin,
  cancellationGroup,
  limit,
  cursorKey,
  filter,
}: FetchMaterializedTableInput): Promise<TableResultOutputV1> => {
  const { data } = await sqTablesApi.queryTableData(
    {
      limit: limit || MAX_TABLE_ROWS,
      columnsToInclude,
      propertiesToInclude,
      includeOverrides,
      tableFormulas,
      tablesToJoin,
      sorts: [],
      ...(cursorKey && {
        cursor: {
          cursorKey,
        },
      }),
      filter,
    },
    { tableId: tableDefinitionId },
    { cancellationGroup },
  );
  return data;
};

export const getMaterializedTable = async (
  tableDefinitionId: string,
  columnsToInclude?: string[],
  propertiesToInclude?: PropertiesForItemUUIDColumn[],
  cancellationGroup?: string,
  limit?: number,
  cursorKey?: string,
  filter?: Filter,
  tablesToJoin?: TableJoinInput[],
): Promise<TableResultOutputV1 | undefined> => {
  try {
    return await fetchMaterializedTable({
      tableDefinitionId,
      columnsToInclude,
      propertiesToInclude,
      includeOverrides: true,
      cancellationGroup,
      limit,
      cursorKey,
      filter,
      tablesToJoin,
    });
  } catch (e) {
    if (!isCanceled(e)) {
      errorToast({ httpResponseOrError: e });
    }
    return undefined;
  }
};

export interface ConditionTableStat {
  statistic: string;
  columnName?: string;
  itemId?: string;
}
